import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

function TermsOfService() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          이용약관
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            제 1 조 (목적)
          </Typography>
          <Typography variant="body1" paragraph>
            본 약관은 황금거북이(이하 "회사")가 제공하는 서비스의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 2 조 (정의)
          </Typography>
          <Typography variant="body1" paragraph>
            1. "서비스"란 회사가 제공하는 모든 서비스를 의미합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            2. "이용자"란 본 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            3. "회원"이란 회사와 서비스 이용계약을 체결하고 이용자 아이디(ID)를 부여받은 이용자를 말합니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 3 조 (약관의 게시와 개정)
          </Typography>
          <Typography variant="body1" paragraph>
            1. 회사는 본 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            2. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 4 조 (서비스의 제공 및 변경)
          </Typography>
          <Typography variant="body1" paragraph>
            1. 회사는 다음과 같은 서비스를 제공합니다:
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 황금거북이 리워드 서비스<br />
            - 리워드 적립 및 관리 서비스<br />
            - 출금 및 보상 관리 서비스
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 5 조 (서비스의 중단)
          </Typography>
          <Typography variant="body1" paragraph>
            1. 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 6 조 (회원가입)
          </Typography>
          <Typography variant="body1" paragraph>
            1. 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            2. 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            제 7 조 (회원 탈퇴 및 자격 상실)
          </Typography>
          <Typography variant="body1" paragraph>
            1. 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            2. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
            최종 수정일: {new Date().toLocaleDateString('ko-KR')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default TermsOfService;
